import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../app/hooks";
import { siteApiSlice } from "../../app/siteApiSlice";
import { resetUserState } from "../../app/userSlice";
import { useLogoutMutation } from "../login/loginApiSlice";
import { resetAccessibility } from "../accessibility/accessibilityUtil";
import { useEffect } from "react";
import { resetFilters } from "../../app/adminReportsFilterSlice";

export default function Logout() {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();
	const [logout] = useLogoutMutation();

	useEffect(() => {
		logout()
			.unwrap()
			.finally(() => {
				sessionStorage.removeItem("isLegacyLoggedIn");
				resetAccessibility();
				dispatch(resetUserState());
				dispatch(resetFilters());
				dispatch(siteApiSlice.util.resetApiState());
				navigate("/login");
			});
	}, []);

	return null;
}
